import React from 'react';
import {Navigate, useLocation} from "react-router-dom";
import {useOrganization} from "../organizations/organization-context";
import {useQuery} from "../../utils/function-util";

export const OrganizationRoute = ({
                                      component: TargetComponent,
                                      ...props
                                  }: any) => {
    const location = useLocation();
    const query = useQuery();
    const organizationId = parseInt(query.get('organizationId') as string) || undefined;
    const [currentOrganization] = useOrganization();

    if (!currentOrganization || (organizationId && currentOrganization?.id !== organizationId)) {
        const restQueryParams = Array
                .from(query.entries())
                .filter(([k]) => k !== 'organizationId' && k !== 'returnUrl')
            .reduce((acc, [k,v]) => `${acc ? acc+'&': acc}${k}=${v}`, '');

        const returnUrl = encodeURIComponent(`${location.pathname}?${restQueryParams}`);
        const redirectPath = `/organizations?organizationId=${organizationId}&returnUrl=${returnUrl}`;

        return <Navigate to={redirectPath}
                         replace={false}
        />
    } else
        return <TargetComponent {...props}
                                currentOrganization={currentOrganization}
        />
};
